export enum RescuedAppointmentsType {
  NoShow = "no_show",
  Cancelled = "cancelado",
  Unscheduled = "nao_agendado",
}
